import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import PersonView from "../PersonView";
import EmailRenderer from "./EmailRenderer";
import PhoneNumberRenderer from "./PhoneNumberRenderer";

interface ModalPersonRendererProps
{
    data: Person;
}

export default class ModalPersonRenderer extends React.Component<ModalPersonRendererProps>
{
    render(): React.ReactNode
    {
        return (<Fragment>
            <Row>
                <Col><PersonView data={this.props.data} /></Col>
            </Row>
            <Row style={{ marginTop: "30px" }}>
                <Col className="ml-5">
                    {
                        this.props.data.officeLocation
                        &&
                        <Row><Col><i className="fas fa-building"></i> <span><b>{this.props.data.officeLocation}</b></span></Col></Row>
                    }
                    {
                        this.props.data.email
                        &&
                        <Row><Col><i className="fas fa-envelope"></i> <span><EmailRenderer value={this.props.data.email} /></span></Col></Row>
                    }
                    {
                        this.props.data.officePhone
                        &&
                        <Row><Col><i className="fas fa-phone"></i> <span><PhoneNumberRenderer value={this.props.data.officePhone} /></span></Col></Row>
                    }
                </Col>
            </Row>
        </Fragment>);
    }
}